module.exports = __webpack_public_path__ + "static/zoe-web-samsung@2x-00521f1bb379078912c2f1588d4e6bf6.jpg";